const quotes = {
    en:[
        {
            quote: 'I believe in analysis and not forecasting',
            by: 'Nicolas Darvas'
        },
        {
            quote: 'The hard work in trading comes in the preparation. The actual process of trading, however, should be effortless',
            by: 'Jack Schwager'
        },
        {
            quote: 'Do more of what works and less of what doesn’t',
            by: 'Steve Clark'
        },
        {
            quote: 'I  know where I’m getting out before I get in',
            by: 'Bruce Kovner'
        },
        {
            quote: 'Risk Management is the key for the 99% successful traders. The remaining 1% are just lucky ones',
            by: 'Camilo Tobar'
        },
        {
            quote: 'Money is made by sitting, not trading',
            by: 'Jesse Livermore'
        },
        {
            quote: 'We simply attempt to be fearful when others are greedy and to be greedy only when others are fearful',
            by: 'Warren Buffett'
        },
        {
            quote: 'Don’t blindly follow someone, follow market and try to hear what it is telling you',
            by: 'Jaymin Shah'
        },
    ],
    es: [
        {
            quote: 'Yo creo en el análisis y no en la especulación',
            by: 'Nicolas Darvas'
        },
        {
            quote: 'El trabajo duro en el trading está en la preparación. Sin embargo, el acto de operar debe de hacerse sin esfuerzo alguno',
            by: 'Jack Schwager'
        },
        {
            quote: 'Continúa haciendo más de lo que funciona y menos de lo que no funciona',
            by: 'Steve Clark'
        },
        {
            quote: 'Sé donde sacar mi trade, antes de entrar a él',
            by: 'Bruce Kovner'
        },
        {
            quote: 'La gestión de riesgo es la clave para el 99% de los traders exitosos. El restante 1% son solo traders con suerte',
            by: 'Camilo Tobar'
        },
        {
            quote: 'El dinero es hecho a través del análisis, no solo operando',
            by: 'Jesse Livermore'
        },
        {
            quote: 'Nosotros simplemente tratamos de ser temerosos cuando otros son codiciosos y ser codiciosos cuando otros son temerosos',
            by: 'Warren Buffett'
        },
        {
            quote: 'No sigas a alguien a ciegas, sigue el mercado y trata de escuchar lo que te está diciendo',
            by: 'Jaymin Shah'
        },

    ]
};

export default quotes;
